import React from 'react';


const BODCard = (props)=>{

    const boardOfDirectors = props.boardOfDirectors.data;

    return(

        <>

        {
            boardOfDirectors.map((BOD,index)=>{

                return(

                    <div key={index} className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-wrap">
                        <div className="img-block">
                            <img src={BOD.img} className="shadow" alt="" />
                        </div>
                        <div className="content">
                            <p>
                                {BOD.name}
                            </p>
                            <p>
                                {BOD.qualification}
                            </p>
                        </div>
                    </div>
                );
            })
        }

        </>
        
    );

}


export default BODCard;